import React from 'react';
import { TimeMap } from '../../../../../elements-date-time/data/time-data';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import moment from 'moment';

const translationMessages = defineMessages({
  startTime: {
    id: 'hosting.select_time_field_hoc.start_time',
    defaultMessage: 'start time'
  },
  endTime: {
    id: 'hosting.select_time_field_hoc.end_time',
    defaultMessage: 'end time'
  }
});

const SelectTimeFieldHOC = (intl, WrappedComponent) => {
  class HOC extends React.Component {
    startTimeOptions () {
      const startTimes = _.filter(TimeMap, (v, k) => { return 35 >= k; });
      return startTimes.map(timeObj => {
        const { time_index: timeIndex, time } = timeObj;
        return { value: timeIndex, label: intl.formatTime(moment(time, 'LT').format())};
      });
    }

    endTimeOptions () {
      const endTimes = _.filter(TimeMap, (time) => {
        if (this.props.maxEndTime) {
          return (
            this.props.startTimeIndex < time.time_index &&
            time.time_index <= this.props.maxEndTime
          );
        }
        return this.props.startTimeIndex < time.time_index;
      });

      return endTimes.map(timeObj => {
        const { time_index: timeIndex, time } = timeObj;
        return { value: timeIndex, label: intl.formatTime(moment(time, 'LT').format()) };
      });
    }

    render () {
      const options = this.props.isStartTime ? this.startTimeOptions() : this.endTimeOptions();
      const placeholder = this.props.isStartTime ? intl.formatMessage(translationMessages.startTime) : intl.formatMessage(translationMessages.endTime);

      return (
        <WrappedComponent
          placeholder={placeholder}
          options={options}
          {...this.props}
        />
      );
    }
  }
  HOC.propTypes = {
    isStartTime: PropTypes.bool,
    startTimeIndex: PropTypes.number
  };
  return HOC;
};

export default SelectTimeFieldHOC;
